import { render, staticRenderFns } from "./course.vue?vue&type=template&id=2fdf3d41&scoped=true"
import script from "./course.vue?vue&type=script&lang=js"
export * from "./course.vue?vue&type=script&lang=js"
import style0 from "./course.vue?vue&type=style&index=0&id=2fdf3d41&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf3d41",
  null
  
)

export default component.exports